export default __webpack_public_path__ + "static/media/7C1-DPLWHG_N-338_Navajo.a0a4736a.png";